<template>
    <div class="flex shadow-lg">
        <div
            class="flex flex-col w-full p-2 bg-white border-4 rounded-sm shadow"
            style="border-color: #12b5cb; color: #67828f"
        >
            <p class="text-md">{{ point.title }}</p>
            <p class="text-sm">{{ point.long_text }}</p>
            <a
                class="text-sm underline"
                :href="point.website_link"
                target="_blank"
                style="color: #fcbb3d"
                >More info</a
            >
        </div>
    </div>
</template>
<script>
export default {
    props: ['point'],
    name: 'PointOfInterestCard',
    data() {
        return {
            defaultImg:
                'https://assets.entrepreneur.com/content/3x2/2000/20151215195453-business-leader-group-front-leadership-team-professionals-businesspeople.jpeg',
        }
    },
    methods: {},
}
</script>
